import { getElements } from '../Utility/Dom'
import { reinitOnSwap } from '../Utility/SwapReinit'

// Filters the list of dates inside the Termine accordion by format
// (Alle / Präsenz / Live Online / E-Learning). Filter buttons carry
// `data-filter="<format-key|all>"`, date rows carry `data-format`.
class CourseDatesFilter {
  private readonly filterGroups: NodeListOf<HTMLElement>

  constructor() {
    this.filterGroups = getElements('course-dates-filter')
  }

  public init(): void {
    this.filterGroups.forEach((group): void => {
      const targetId = group.getAttribute('data-target')
      if (!targetId) return

      const targetList = document.getElementById(targetId)?.querySelector<HTMLElement>('[data-js="course-dates-list"]')
      if (!targetList) return

      const buttons = group.querySelectorAll<HTMLButtonElement>('button[data-filter]')
      buttons.forEach((button): void => {
        button.addEventListener('click', (): void => {
          this.applyFilter(buttons, button, targetList)
        })
      })
    })
  }

  private applyFilter(buttons: NodeListOf<HTMLButtonElement>, active: HTMLButtonElement, list: HTMLElement): void {
    buttons.forEach((button): void => {
      const isActive = button === active
      button.classList.toggle('is-active', isActive)
      button.setAttribute('aria-pressed', String(isActive))
    })

    const filter = active.getAttribute('data-filter') ?? 'all'
    const rows = list.querySelectorAll<HTMLElement>('[data-format]')
    rows.forEach((row): void => {
      const matches = filter === 'all' || row.getAttribute('data-format') === filter
      row.hidden = !matches
    })
  }
}

const courseDatesFilter = new CourseDatesFilter()
courseDatesFilter.init()
reinitOnSwap(() => new CourseDatesFilter())
